import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const CUES = ["ROLL SOUND", "ROLL CAMERA", "SPEED", "MARK IT", "ACTION"];

export const Preloader = ({ onDone }) => {
  const [i, setI] = useState(0);
  const [show, setShow] = useState(true);

  useEffect(() => {
    const t = setInterval(() => setI((v) => Math.min(v + 1, CUES.length - 1)), 260);
    const end = setTimeout(() => {
      setShow(false);
      onDone();
    }, 1500);
    return () => {
      clearInterval(t);
      clearTimeout(end);
    };
  }, [onDone]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="preloader"
          className="fixed inset-0 z-[90] bg-[var(--ink)] text-[var(--paper)] flex items-center justify-center paper-grid"
          exit={{ y: "-100%" }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
        >
          <div className="text-center">
            <div className="font-mono text-xs tracking-[0.3em] text-[var(--yellow)] mb-4">SCENE 01 · TAKE 01</div>
            <div className="pixel-title text-5xl md:text-7xl h-[1em] overflow-hidden">
              <AnimatePresence mode="popLayout">
                <motion.div key={i} initial={{ y: "100%" }} animate={{ y: 0 }} exit={{ y: "-100%" }} transition={{ duration: 0.22 }}>
                  {CUES[i]}
                </motion.div>
              </AnimatePresence>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
